import React, {FC, useEffect, useMemo, useState} from "react";
import {Box, Chip} from "@material-ui/core";
import clsx from "clsx";
import useStyles from "./styles";

export type BadgeAlertProps = {
  badgeCount?: number;
  calculateBadgeCount?: () => Promise<number>;
  className?: string;
  containerClassName?: string;
};

type BadgeCount = {
  loading: boolean;
  count: number;
};

const BadgeAlert: FC<BadgeAlertProps> = ({
  badgeCount: providedBadgeCount,
  calculateBadgeCount,
  className,
  containerClassName,
}) => {
  const classes = useStyles();

  const [badgeCount, setBadgeCount] = useState<BadgeCount>({
    loading: true,
    count: 0,
  });

  const badgeNumber = useMemo(() => providedBadgeCount ?? badgeCount.count, [
    badgeCount.count,
    providedBadgeCount,
  ]);

  useEffect(() => {
    if (!calculateBadgeCount) {
      return;
    }

    const refreshBadgeCount = async () => {
      const count = await calculateBadgeCount();
      setBadgeCount({loading: false, count});
    };

    refreshBadgeCount();
  }, [calculateBadgeCount]);

  const renderBadge = () => {
    if (!badgeNumber) {
      return null;
    }

    return (
      <Chip
        className={clsx(classes.badge, className)}
        color="secondary"
        size="small"
        label={badgeNumber}
      />
    );
  };

  return badgeNumber ? (
    <Box className={clsx(classes.badgeContainer, containerClassName)}>
      {renderBadge()}
    </Box>
  ) : null;
};

export default BadgeAlert;
